<template>
  <div class="bcc-table__wrap">
    <slot name="loading">
      <div class="loading_wrap" v-if="showLoading">
          <div class="loading-content">
          <img src="//s1.hdslb.com/bfs/seed/bplus-common/dynamic-assets/loading.png"><span>loading</span>
          </div>
      </div>
     </slot>
    <table
      :class="{
        'bcc-table__border': border,
        'bcc-table__align-left': align === 'left',
        'bcc-table__align-center': align === 'center',
        'bcc-table__align-right': align === 'right'
      }"
      cellspacing="0"
      cellpadding="0"
      border="0">
      <thead>
        <tr>
          <th
            v-if="rowSelection"
            :style="rowSelection.style"
            :max-width="rowSelection.style && rowSelection.style['max-width']"
            class="bcc-table__row-selection">
            <div class="bcc-table__cell">
              <bcc-checkbox
                :indeterminate="checkAll === 'indeterminate'"
                :value="checkAll"
                @on-change="rowSelectionChangeAll"
                label="">
              </bcc-checkbox>
            </div>
          </th>
          <th
            v-for="column in columns"
            :key="column.key"
            :style="column.style">
            <div
              :class="{
                'bcc-table__cell': true,
                'bcc-table__cell-sort': column.sortable
              }"
              @click="sortHandle(column)">
              <slot :name="`th-${column.key}`">
                {{ column.title }}
              </slot>
              <span
                class="bcc-table__sort"
                v-if="column.sortable">
                <bcc-icon type="ic_sortin_on" :class="{ 'bcc-table__sort-color': sort.key === column.key && sort.val === 1 }"></bcc-icon>
                <bcc-icon type="ic_sortin_un" :class="{ 'bcc-table__sort-color': sort.key === column.key && sort.val === 2 }"></bcc-icon>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          :class="{ 'bcc-table__tr-hover': hover }"
          v-for="(row, index) in data"
          :key="index"
          @click="rowClick(row, $event)">
          <td
            v-if="rowSelection"
            :style="rowSelection.style"
            class="bcc-table__row-selection">
            <div class="bcc-table__cell">
              <bcc-checkbox
                :value="rowSelection.selectedRowKeys.indexOf(index) !== -1"
                @on-change="rowSelectionChange(index)"
                label="">
              </bcc-checkbox>
            </div>
          </td>
          <td
            v-for="column in columns"
            :key="column.key"
            :style="column.style">
            <div class="bcc-table__cell">
              <slot :name="column.key" :row="row" :$index="index">
                {{ row[column.key] }}
              </slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div :class="{
      'bcc-table__empty': true,
      'bcc-table__empty-border': border}"
      v-if="data.length === 0">
      <slot name="empty">
        <bcc-state class="bcc-table__empty-default" type="empty" :tip="emptyText" />
      </slot>
    </div>
  </div>
</template>

<script>
import { Checkbox as BccCheckbox } from '../checkbox'
import BccIcon from '../icon'
import BccState from '../state'

export default {
  name: 'BccTable',
  data () {
    return {
      sort: {
        key: '',
        val: 0
      }
    }
  },
  components: {
    BccCheckbox,
    BccIcon,
    BccState
  },
  props: {
    columns: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    },
    rowSelection: {
      type: Object,
      default: null
    },
    border: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'left'
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    showLoading: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: {
    checkAll () {
      const selectedLength = this.rowSelection.selectedRowKeys.length
      if (selectedLength === 0) {
        return false
      } else if (selectedLength === this.data.length) {
        return true
      } else {
        return 'indeterminate'
      }
    }
  },
  methods: {
    rowSelectionChange (val) {
      const set = new Set(this.rowSelection.selectedRowKeys)
      if (set.has(val)) {
        set.delete(val)
      } else {
        set.add(val)
      }
      const arr = Array.from(set)
      this.rowSelection.onChange(arr)
    },
    rowSelectionChangeAll () {
      let arr = []
      if (this.checkAll !== true) {
        arr = this.data.map((item, index) => index)
      }
      this.rowSelection.onChange(arr)
    },
    sortHandle (column) {
      const { sortable } = column
      if (!sortable) {
        return
      }
      const key = column.key
      const sort = { key, sortable }
      if (sort.key === this.sort.key) {
        sort.val = this.sort.val === 2 ? 0 : this.sort.val + 1
      } else {
        sort.val = 1
      }
      this.sort = sort
      this.$emit('sort-change', {
        key,
        order: [null, 'ascending', 'descending'][sort.val]
      })
    },
    rowClick (row, event) {
      this.$emit('row-click', row, event)
    }
  },
  watch: {
    sort () {
      const { key, val, sortable } = this.sort
      if (val !== 0) {
        if (sortable === 'custom') {
          return
        }
        this.data.sort((a, b) => {
          if (a[key] > b[key]) {
            return val === 1 ? 1 : -1
          } else if (a[key] < b[key]) {
            return val === 1 ? -1 : 1
          } else {
            return 0
          }
        })
      }
    }
  },
  mounted () {
  }
}
</script>
